import { fetchAllRecords } from "config/airtable";
import React, { createContext, useState, useEffect, useContext } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [awards, setAwards] = useState([]);
  // const [scoring, setScoring] = useState([]);
  // const [juniorDivisionProjects, setJuniorDivisionProjects] = useState([]);
  // const [seniorDivisionProjects, setSeniorDivisionProjects] = useState([]);
  const [fairEvent, setFairEvent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      setError(null);

      try {
        // 1) fetch projects & students
        const [projectsRecs, studentsRecs] = await Promise.all([
          fetchAllRecords("projects"),
          fetchAllRecords("students"),
        ]);
        console.log("projects:", projectsRecs);
        setProjects(projectsRecs);
        setStudents(studentsRecs);

        // 2) fetch all fair_year records and pick this year's event
        const fairRecs = await fetchAllRecords("fair_year");
        const currentYear = new Date().getFullYear();
        const fairRec = fairRecs.find((r) => r.data.Year === currentYear);

        if (!fairRec) {
          console.warn(`No fair event found for year ${currentYear}`);
        } else {
          setFairEvent(fairRec.data);

          // 3) fetch all awards, then client-side filter by linked fair_year ID
          const allAwards = await fetchAllRecords("awards");
          const filteredAwards = allAwards.filter(
            (awardRec) =>
              Array.isArray(awardRec.data.fair_year) &&
              awardRec.data.fair_year.includes(fairRec.id)
          );

          filteredAwards.sort(
            (a, b) =>
              (a.data.presentation_order ?? 0) -
              (b.data.presentation_order ?? 0)
          );
          console.log(
            `Filtered awards for fair year ${fairRec.id}:`,
            filteredAwards.length
          );
          console.log(filteredAwards);
          setAwards(filteredAwards);
        }

        // (add additional fetches here for scoring, divisions, etc.)
      } catch (err) {
        console.error("Error fetching all data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  if (loading) return <div>Loading…</div>;

  return (
    <DataContext.Provider
      value={{
        projects,
        students,
        awards,
        // scoring,
        // juniorDivisionProjects,
        // seniorDivisionProjects,
        fairEvent,
        error,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

// Custom hook for accessing the DataContext
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
